import { isRunningStandalone } from './pwa-install';

/**
 * Installeret app (Føj til hjemmeskærm / standalone): lås sidens zoom, ligesom en native app.
 * Uden låsen kan et dobbelttryk eller en kort-pinch zoome selve siden på iPhone, så den faste bundmenu "svæver"
 * over skærmkanten, toppen bliver pixeleret, og swipes panorerer den zoomede side i stedet for appens scroll.
 * I en almindelig browserfane forbliver zoom tilladt (tilgængelighed; Safari ignorerer låsen alligevel).
 */
export const BROWSER_VIEWPORT = 'width=device-width, initial-scale=1.0, viewport-fit=cover';
export const STANDALONE_VIEWPORT =
  'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';

export function applyStandaloneViewport(
  standalone: boolean = isRunningStandalone(),
  doc: Pick<Document, 'querySelector'> = document,
): string | null {
  const meta = doc.querySelector('meta[name="viewport"]');
  if (!meta) return null;
  const content = standalone ? STANDALONE_VIEWPORT : BROWSER_VIEWPORT;
  meta.setAttribute('content', content);
  return content;
}
